<template>
  <div>
    <div v-if="this.$route.path=='/report/reporttool/subscribeReport'">
      <div class="page-title">订阅报表</div>
      <!-- 查询 -->
      <el-form class="query-form" label-width="80px" :model="queryForm">
        <div class="searchBox">
          <el-input v-model="queryForm.subscribeTitle" placeholder="请输入邮件标题"></el-input>
          <el-button @click="subscribeTemplateList"><i class="iconfont icon-sousuo"></i></el-button>
        </div>
        <!-- <el-form-item label="邮件标题">
          <el-input v-model="queryForm.emailTitle" class="input-with-select">
            <el-button slot="append" icon="iconfont icon-sousuo"></el-button>
          </el-input>
        </el-form-item> -->
        <el-button v-permission="'subscribe:config:save'"
        @click="editItem('add')" class="fr" type="primary" size="medium" icon="iconfont icon-tianjia-copy">新建订阅</el-button>
      </el-form>
      <!-- 表格 -->
      <el-table class="center-table roleTable"
        :data="tableData" v-loading="tableLoading"
        border style="width: 100%">
        <el-table-column
          prop="subscribeTitle"
          label="邮件标题">
          <template slot-scope="scope">
            <!-- <router-link :to ="{name:'subscribeReportDetails'}">{{scope.row.title}}</router-link> -->
            <el-link type="primary"
            @click="$router.push({path: '/report/reporttool/subscribeReport/subscribeReportDetails',query: {'name': scope.row.subscribeTitle, 'id': scope.row.id}})">
            {{scope.row.subscribeTitle}}</el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="reportName"
          label="关联报表">
        </el-table-column>
        <el-table-column
          width="200"
          prop=""
          label="操作">
          <template slot-scope="scope">
            <!-- <el-button v-if="checkPermission('subscribe:config:id')" :disabled="scope.row.status === 0" type="text" size="small" @click="editItem(scope.row)">编辑</el-button> -->
            <el-button type="text" size="small" @click="editItem('copy', scope.row)">复制</el-button>
            <el-button type="text" size="small" @click="editItem('see', scope.row)">查看</el-button>
            <el-button type="text" size="small" @click="deleteItem(scope.row)">删除</el-button>
        </template>
        </el-table-column>
        <el-table-column
          width="200"
          label="状态">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status" @change="changeStatus($event,scope.row)" :active-value="1" :inactive-value="0"></el-switch>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="paging-box" v-if="pageTotal > 0">
        <!-- <span class="page-total">显示全部项目{{pageTotal}}个项目</span> -->
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="queryForm.pageNum"
          :page-sizes="[10, 20, 40, 80, 100]"
          @size-change="handleSizeChange"
          :page-size="queryForm.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="pageTotal">
        </el-pagination>
      </div>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
export default {
  name: 'subscribeReport',
  data () {
    return {
      tableLoading: false,
      // 查询表单
      queryForm: {
        subscribeTitle: '',
        // 分页
        pageNum: 1,
        pageSize: 10 // 每页显示的数据条数
      },
      // 分页
      pageTotal: 0,
      // 表格数据
      tableData: []
    }
  },
  created () {
    if (this.$route.path === '/report/reporttool/subscribeReport') {
      this.subscribeTemplateList()
    }
  },
  methods: {
    editItem(type, row) {
      let param = {
        'type': type
      }
      if (row) {
        // param.name = row.subscribeTitle
        param.id = row.id
      }
      this.$router.push({path: '/report/reporttool/subscribeReport/addSubscribeReport', query: param})
    },
    deleteItem(row) {
      this.$confirm('确认要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$service
            .post('/api/subscribe/config/status', {
              id: row.id,
              status: 2 // 0停用1正常 2删除
            })
            .then(res => {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              // 刷新列表
              this.subscribeTemplateList()
            })
            .catch(Err => {
              // console.log(Err)
            })
        }).catch(Err => {
        })
    },
    // 切换分页
    handleCurrentChange (val) {
      this.subscribeTemplateList()
    },
    // 切换数据显示条数
    handleSizeChange (size) {
      this.queryForm.pageSize = size
      this.subscribeTemplateList()
    },
    // 获取表格数据
    subscribeTemplateList () {
      // 开启tableLoading
      this.tableLoading = true
      this.$service.post('/api/subscribe/config/list', this.queryForm).then(res => {
        if (res.code === 200) {
          // 关闭tableLoading
          this.tableLoading = false
          this.tableData = res.result.pageData
          this.pageTotal = res.result.total
        }
      }).catch(Err => {})
    },
    // 状态开关
    changeStatus (event, item) {
      item.status = item.status === 0 ? 1 : 0
      this.$confirm('确认修改报表状态吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        let status = item.status === 0 ? 1 : 0
        this.$service.post('/api/subscribe/config/status', {'id': item.id, 'status': status}).then(res => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
            item.status = item.status === 0 ? 1 : 0
          }
        }).catch(Err => {})
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    }
  },
  watch: {
    // 监测弹窗
    $route (to) {
      if (to.path === '/report/reporttool/subscribeReport') {
        this.subscribeTemplateList()
      }
    }
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/views/report/subscribeReport.vue